import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Skeleton } from 'antd';

interface SkeletonLoaderProps {}

const SkeletonLoader = function ({}: SkeletonLoaderProps): ReactElement {
  return (
    <>
      <SkeletonWrapper>
        <Skeleton active={true} />
      </SkeletonWrapper>
      <SkeletonWrapper>
        <Skeleton active={true} />
      </SkeletonWrapper>
    </>
  );
};

const SkeletonWrapper = styled.div`
  margin-bottom: 20px;
`;

export { SkeletonLoader };
